import { Box, TextField, Button, Typography, useTheme } from "@mui/material";
import { BaseStepProps } from "../types/types";
import { tokens } from "../../../theme";

interface StepProps extends BaseStepProps {
  onNext: () => void;
  onPrevious: () => void;
}

export default function Step3Finance({
  formData,
  onChange,
  onPrevious,
  onNext,
  onSaveGear,
}: StepProps) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Purchase Cost
          </Typography>
          <TextField
            fullWidth
            placeholder="e.g. 2 500"
            size="small"
            value={formData.purchaseCost}
            onChange={(e) => onChange("purchaseCost", e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Current Value
          </Typography>
          <TextField
            fullWidth
            placeholder="e.g. 2 500"
            size="small"
            value={formData.currentValue}
            onChange={(e) => onChange("currentValue", e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Purchase date
          </Typography>
          <TextField
            fullWidth
            type="date"
            size="small"
            value={formData.purchaseDate}
            onChange={(e) => onChange("purchaseDate", e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Warranty Expiry
          </Typography>
          <TextField
            fullWidth
            type="date"
            size="small"
            value={formData.warrantyExpiry}
            onChange={(e) => onChange("warrantyExpiry", e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
      </Box>
      <Box sx={{ width: { xs: "100%", sm: "48%" } }}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: colors.primary[400],
            mb: 0.5,
            fontSize: "0.88rem",
          }}
        >
          Rental Value per day
        </Typography>
        <TextField
          fullWidth
          placeholder="e.g. 50"
          size="small"
          value={formData.rentalValue}
          onChange={(e) => onChange("rentalValue", e.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: colors.primary[800],
              borderRadius: "16px",
              "& fieldset": { border: "none" },
              "&:hover fieldset": { border: "none" },
              "&.Mui-focused fieldset": { border: "none" },
            },
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 2,
        }}
      >
        <Box sx={{ display: "flex", gap: 3 }}>
          <Typography
            onClick={onPrevious}
            sx={{
              cursor: "pointer",
              fontWeight: 600,
              textDecoration: "underline",
              color: colors.primary[400],
              fontSize: "0.9rem",
            }}
          >
            Previous
          </Typography>
          <Typography
            onClick={onSaveGear}
            sx={{
              cursor: "pointer",
              fontWeight: 600,
              textDecoration: "underline",
              color: colors.primary[400],
              fontSize: "0.9rem",
            }}
          >
            Save Gear
          </Typography>
        </Box>
        <Button
          variant="contained"
          size="large"
          onClick={onNext}
          sx={{
            backgroundColor: colors.primary[400],
            px: 5,
            py: 1.2,
            borderRadius: "24px",
            "&:hover": { backgroundColor: colors.primary[500] },
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
}
